<template>
    <div class="App-layout" :style="{ '--safezone-bottom': safeZoneBottom }">
        <div class="container" :class="[hideMenu ? 'menu-hidden' : '']">
            <div
                id="scroll-container"
                class="no-scrollbar relative flex flex-col overflow-x-hidden overflow-y-scroll"
                :style="`border-top: ${safeZoneTop} solid var(--color-bg);`"
            >
                <slot />
            </div>

            <menu-footer :hidden="hideMenu" />
        </div>
    </div>

    <game-explanation />

    <MatchInviteModal
        :invite="matchInviteStore.invite"
        :is-visible="matchInviteStore.isModalVisible"
        @accept-success="handleAcceptSuccess"
        @accept-error="handleAcceptError"
        @decline-success="handleDeclineSuccess"
        @decline-error="handleDeclineError"
        @close="matchInviteStore.closeModal"
    />
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import { useMatchInviteStore } from '@/stores/matchInvite.js'
import MatchInviteModal from '@/components/MatchInviteModal.vue'
import MenuFooter from '@/components/ui/navigation/Menu.vue'
import GameExplanation from '@/components/GameExplanations.vue'

export default {
    name: 'AppLayout',
    components: {
        MatchInviteModal,
        MenuFooter,
        GameExplanation,
    },
    computed: {
        ...mapStores(useAuthStore, useMatchInviteStore),

        currentRouteName() {
            return this.$route?.name || ''
        },
        hideMenu() {
            return this.$route?.meta?.hideMenu || false
        },
        safeZoneTop() {
            return (document.safeZone ? document.safeZone.top : 0) + 'px'
        },
        safeZoneBottom() {
            return (document.safeZone ? document.safeZone.bottom : 0) + 'px'
        },
    },
    methods: {
        handleAcceptSuccess(invite) {
            const match = invite?.data?.match || invite?.match
            if (match?.online && match?.id) {
                this.$router.push({
                    name: 'match-lobby',
                    params: { matchId: match.id },
                })
                return
            }
            this.$router.push({ name: 'home' })
        },
        handleAcceptError(error) {
            console.error('Failed to accept invite:', error)
            this.$toast(
                'Something went wrong',
                5000,
                'Failed to accept invitation. Please try again.',
            )
        },
        handleDeclineSuccess() {
            console.log('Invite declined successfully')
        },
        handleDeclineError(error) {
            console.error('Failed to decline invite:', error)
        },
    },
}
</script>

<style lang="scss">
.App-layout {
    width: 100vw;
    height: 100dvh;
    overflow: hidden;

    .container {
        display: grid;
        grid-template-columns: 100vw;
        /* two rows: main area + footer/menu height */
        grid-template-rows:
            calc(100dvh - (64px + var(--safezone-bottom, 0px)))
            calc(64px + var(--safezone-bottom, 0px));
        transition: all 500ms;

        &.menu-hidden {
            /* collapse middle content; show only full viewport + safe zone row */
            grid-template-rows: 100dvh var(--safezone-bottom, 0px);

            .menu-Container {
                padding-top: 5px;
            }
        }
    }
}
</style>
